/**
 * Icon Style Utilities
 *
 * Shared styles for SVG icons within interactive components.
 * Ensures consistent icon behavior across buttons, menu items, etc.
 */

/**
 * Base icon styles for interactive components
 * - pointer-events-none: Prevents icons from capturing click events
 * - shrink-0: Prevents icons from shrinking in flex layouts
 */
export const ICON_BASE = '[&_svg]:pointer-events-none [&_svg]:shrink-0';

/**
 * Default icon size (16px / 1rem)
 * Only applied if the icon doesn't have an explicit size class
 */
export const ICON_SIZE_4 = "[&_svg:not([class*='size-'])]:size-4";

/**
 * Smaller icon size (14px / 0.875rem)
 * For compact UI elements
 */
export const ICON_SIZE_3_5 = "[&_svg:not([class*='size-'])]:size-3.5";

/**
 * Larger icon size (20px / 1.25rem)
 * For larger buttons and inputs
 */
export const ICON_SIZE_5 = "[&_svg:not([class*='size-'])]:size-5";

/**
 * Combined base + default size
 * Most common pattern for interactive elements
 */
export const ICON_DEFAULT = `${ICON_BASE} ${ICON_SIZE_4}`;
